import { FC, JSX } from 'react';

import { Button, Empty, Flex, Form, FormListFieldData } from 'antd';
import classNames from 'classnames';

import { TVerticalTableProps, VerticalTable } from '@/components/vertical-table';

import styles from './DebtsMobileTable.module.scss';

import { BusinessDebtDto } from '@/generated-types';
import { getFormattedAmount } from '@/utils';

type TDebtsMobileTableProps = Omit<TVerticalTableProps<FormListFieldData>, 'rowKey'> & {
	add: () => void;
};

export const DebtsMobileTable: FC<TDebtsMobileTableProps> = ({
	columns,
	dataSource,
	add,
}): JSX.Element => {
	const form = Form.useFormInstance();
	const businessDebts = Form.useWatch('businessDebts', form) || [];

	const totalCurrentDebtBalance = businessDebts.reduce(
		(sum: number, row: BusinessDebtDto) => sum + (Number(row?.outstandingBalance) || 0),
		0,
	);
	const totalMonthlyPayment = businessDebts.reduce(
		(sum: number, row: BusinessDebtDto) => sum + (Number(row?.monthlyPayment) || 0),
		0,
	);

	const totalFormattedCurrentDebtBalance = getFormattedAmount(totalCurrentDebtBalance);
	const totalFormattedMonthlyPayment = getFormattedAmount(totalMonthlyPayment);

	return (
		<>
			{dataSource.length === 0 ? (
				<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
			) : (
				<>
					<VerticalTable columns={columns} dataSource={dataSource} rowKey="key" />
					<Flex className={styles['total-container']} gap={8}>
						<Flex className={styles['total']} vertical>
							<span>Total Current Debt Balance:</span>
							<span>Total Monthly Payment:</span>
						</Flex>
						<Flex className={classNames(styles['total'], styles['amount'])} vertical>
							<span>{totalFormattedCurrentDebtBalance}</span>
							<span>{totalFormattedMonthlyPayment}</span>
						</Flex>
					</Flex>
				</>
			)}
			<Flex className={styles['add-button-container']} justify="flex-end">
				<Button className={styles['add-button']} color="primary" variant="outlined" onClick={add}>
					Add Debt
				</Button>
			</Flex>
		</>
	);
};
